// extracted by mini-css-extract-plugin
export default {"container":"hLGoO1JUjdqLlNMfreRL","score":"QLUQxAaWVazmWX6nmc0C","difference":"G7lnrNcfFjvHMTw85qMT"};